const ns = {};

ns.Notifier = function() {
    this.container = $('#tabHeader');

    this.titleMap = Cookies.getJSON('notify_title_text');
};

/**
 * Wenn alles gut lief
 */
ns.Notifier.TYPE_INFO = 'notice';

/**
 * Wenn es Fehler gab
 */
ns.Notifier.TYPE_ERROR = 'error';

/**
 * Warnung; nicht so granvierend wie Fehler
 */
ns.Notifier.TYPE_WARNING = 'warning';

/**
 * Neutrale Meldung
 */
ns.Notifier.TYPE_DEFAULT = 'default';

/**
 *
 * Keine Meldnung! Kann als Rückkanal genutzt werden.
 */
ns.Notifier.TYPE_REPORT = 'report';

/**
 * "Statische" Methode zum Abrufen der Instanz.
 *
 * @returns {ns.Notifier}
 */
ns.Notifier.getInstance = function () {
    if (!ns.Notifier.instance) {
        ns.Notifier.instance = new ns.Notifier();
    }

    return ns.Notifier.instance;
};

/**
 * Fuegt eine Notification hinzu. Funktioniert nur auf Tab-Seiten bzw. solchen
 * mit der passenden HTML-Struktur.
 *
 * @param {String} msg
 * @param {Number} type
 * @param {Number} duration Optionale Anzeigedauer in ms. Default sind 3000.
 *                          0 fuer dauerhafte Anzeige (bis Tabwechsel).
 * @returns {ns.Notifier}
 */
ns.Notifier.prototype.notify = function(msg, type, duration) {
    type = type || ns.Notifier.TYPE_INFO;

    //check for input duration
    if (isNaN(duration)) {
        //use cookie duration
        duration = Cookies.getJSON('notify_duration');
    }

    if (type === 'error') {
        duration = typeof duration === 'undefined' ? 0 : duration;
    }
    if (type === 'notice') {
        duration = typeof duration === 'undefined' ? 3000 : duration;
    }
    if (type === 'warning') {
        duration = typeof duration === 'undefined' ? 6000 : duration;
    }

    var params = {
        message: msg
    };

    if (duration === 0) {
        params.fixed = true;
    } else {
        params.duration = duration;
    }

    params.title = this.titleMap[type];

    if (type != ns.Notifier.TYPE_REPORT) {
        if (type === ns.Notifier.TYPE_DEFAULT) {
            $.growl(params);
        } else {
            $.growl[type](params);
        }
    }

    return this;
};

/**
 * Entfernt alle Notifications.
 *
 * @returns {ns.Notifier}
 */
ns.Notifier.prototype.clearAll = function () {
    $('#growls').remove();
};

export default ns.Notifier;
